import { style, styleVariants } from '@vanilla-extract/css';
import { nToPx, spin, themeVars } from '@tundr/theme';
import { LoaderSize } from './Loader.utils';

export const loaderClass = style([spin, {}]);

export const loaderWrapperClass = style({
  height: 300,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: nToPx(themeVars.space.x4, 0),
});

export const loaderWrapperMinHeightClass = style({
  height: 'auto',
});

export const loaderVariants = styleVariants({
  [LoaderSize.mini]: {
    width: 15,
    height: 15,
  },
  [LoaderSize.small]: {
    width: 22,
    height: 22,
  },
  [LoaderSize.medium]: {
    width: 40,
    height: 40,
  },
  [LoaderSize.large]: {
    width: 60,
    height: 60,
  },
  [LoaderSize.extra]: {
    width: 100,
    height: 100,
  },
});
